import React, { useState, useEffect } from 'react';
import { post } from '../Services/http';
import Select from 'react-select';
import { translate } from '../Services/translation';
import { useCountryList } from '../Hooks/useCountryList';
import { useLanguageList } from '../Hooks/useLanguageList';
import useIsMobile from '../Hooks/useIsMobile';

export default function ChannelPickerContiner(props) {
    const { itemList } = props;
    const [showSettingsBox, setShowSettingsBox] = useState(false);
    const [countryList, setCountryList] = useCountryList(itemList.ChannelPickerItems);
    const [languageList, setLanguageList] = useLanguageList(itemList.ChannelPickerItems, itemList.CurrentCountry);
    const [selectedCountry, setSelectedCountry] = useState(countryList.filter(x => x.value == itemList.CurrentCountry)[0]);
    const [selectedLanguage, setSelectedLanguage] = useState(languageList.filter(x => x.value == itemList.CurrentLanguage)[0]);
    const isMobile = useIsMobile("medium-large");

    const changeCountry = (value) => {
        const newChannelList = setLanguageList(itemList.ChannelPickerItems, value.value)
        setSelectedCountry(value);
        setSelectedLanguage(newChannelList[0]);
        updateValue(value, newChannelList[0]);
    };

    const changeLanguage = (value) => {
        setSelectedLanguage(value);
        updateValue(selectedCountry, value);
    };

    const customSelect = (list, selected, changeFunction) => {
        const customStyles = {
            option: (provided) => ({
                ...provided,
                color: '#181818',
            }),
            control: (provided) => ({
                ...provided,                                                       
                border: 'none',
                boxShadow: 'none',
                marginTop: '-5px'
            }),
            valueContainer: (provided) => ({
                ...provided,
                paddingLeft: '0px',
            }),
            dropdownIndicator: (provided) => ({
                ...provided,
                paddingRight: '0px'
            }),
            singleValue: provided => ({
                ...provided,
                marginLeft: '0px',
                fontSize: '12px',
                color: '#181818'
            }),
            input: provided => ({
                ...provided,
                marginLeft: '0px'
            }),
            menu: provided => ({
                ...provided,
                borderRadius: '0px',
                top: isMobile ? "" : "26px",
                bottom: isMobile ? '26px' : "",
                fontSize: "12px"
            }),
            
        };
        return <Select
            options={list}
            value={list.filter(x => x.label === selected)[0]}
            isSearchable={true}
            onChange={(event) => changeFunction(event)}
            components={{ IndicatorSeparator: () => null }}
            styles={customStyles}
            theme={theme => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#EEEEEE',
                  primary: '#BDBDBD',
                },
              })}
        />
    };

    const setCookie = (cname, cvalue, exdays) => {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
    const updateValue = (country, language) => {
        setCookie('shipping-modal', true, 365);
        let data = {
            CurrentCountry: country.value,
            CurrentLanguage: language.value,
            CurrentPageSystemId: itemList.CurrentPageSystemId,
            CurrentPageType: itemList.CurrentPageType,
        }
        post('/api/channel/update', data)
            .then(response => response.json())
            .then(response => {
                setCookie('countrySet', response.countryId, 2 * 365);
                window.location.href = response.redirect;
            });
    };

    return (
        <>
            <div className="channel-picker">
                <div className="channel-picker__current-currency" onClick={() => setShowSettingsBox(!showSettingsBox)} onClick={() => setShowSettingsBox(!showSettingsBox)}>{itemList.DisplayName}</div>
                {showSettingsBox &&
                    <div className="channel-picker__channel-container">
                        <div className="channel-picker__channel-bottom">
                            <div className="channel-picker__selection-container">
                                <span>{translate('channelpicker.shipto')}:</span>
                                {countryList.length > 0 && selectedCountry &&
                                    customSelect(countryList, selectedCountry.label, changeCountry)
                                }
                            </div>
                            <div className="channel-picker__selection-container">
                                <span>{translate('channelpicker.language')}:</span>
                                {languageList.length > 0 && selectedLanguage &&
                                    customSelect(languageList, selectedLanguage.label, changeLanguage)
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}